import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/** ![gripVerticalIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48Y2lyY2xlIGN4PSI5IiBjeT0iMTIiIHI9IjEiLz48Y2lyY2xlIGN4PSI5IiBjeT0iNSIgcj0iMSIvPjxjaXJjbGUgY3g9IjkiIGN5PSIxOSIgcj0iMSIvPjxjaXJjbGUgY3g9IjE1IiBjeT0iMTIiIHI9IjEiLz48Y2lyY2xlIGN4PSIxNSIgY3k9IjUiIHI9IjEiLz48Y2lyY2xlIGN4PSIxNSIgY3k9IjE5IiByPSIxIi8+PC9zdmc+) */
const gripVerticalIcon = /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx("circle", {
    cx: 9,
    cy: 12,
    r: 1
  }), /*#__PURE__*/jsx("circle", {
    cx: 9,
    cy: 5,
    r: 1
  }), /*#__PURE__*/jsx("circle", {
    cx: 9,
    cy: 19,
    r: 1
  }), /*#__PURE__*/jsx("circle", {
    cx: 15,
    cy: 12,
    r: 1
  }), /*#__PURE__*/jsx("circle", {
    cx: 15,
    cy: 5,
    r: 1
  }), /*#__PURE__*/jsx("circle", {
    cx: 15,
    cy: 19,
    r: 1
  })]
});

export { gripVerticalIcon };
